import moment from 'moment-timezone';
import React from 'react'
import styled from 'styled-components';

import AntdTag from 'antd/lib/tag';

import { Link } from 'react-router-dom';

import Types from '../../modules/types';

export const ColumnTagWrapper = styled.div`
  display: flex;
  // flex-wrap: wrap;
  max-width: 400px;
  overflow-x: scroll;
  overflow-y: auto;
  &-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-width: none;
  scrollbar-width: none;
`;

export const columnEmail = {
  path: 'customerDetails.email',
  title: 'Email',
};

export const columnLastOrder = {
  path: 'lastOrderDate',
  title: 'Last Ordered',
  sort: 'lastOrdered',
  render: record => `${
    moment(record.stats.lastOrderDate).format('DD.MM.YYYY')
  }`,
  align: 'right',
};

export const columnTotalSpent = {
  path: 'totalSpent',
  title: 'Total Spent',
  sort: 'totalSpent',
  render: record => `${
    Types.getSystemCountry(record.systemCountry).currency
  } ${
    Types.decimalize(record.stats.orderCostTotal)
  }`,
  align: 'right',
};

export const columnCities = {
  path: 'cities',
  title: 'Cities',
  render: record => (
    <ColumnTagWrapper>
      {record.cities.map((city, _index) => (
        <AntdTag
          style={{ textTransform: 'capitalize' }}
          key={city}
        >
          {city}
        </AntdTag>
      ))}
    </ColumnTagWrapper>
  ),
};

export const columnCountries = {
  path: 'countries',
  title: 'Countries',
  render: record => (
    <ColumnTagWrapper>
      {
        record.countries.map(country => (
          <AntdTag key={country}>
            {Types.COUNTRIES_MAP[country].name}
          </AntdTag>
        ))
      }
    </ColumnTagWrapper>
  ),
};

export const columnOrdersCountDelivered = {
  path: 'stats.orderCountDelivered',
  title: 'Delivered',
  align: 'right',
  sort: 'orderCountDelivered',
};

export const columnPhoneNumber = {
  path: 'customerDetails.phoneNumberString',
  title: 'Phone #',
};

export const columnStore = {
  path: 'stores',
  title: 'Stores',
  render: record => {
    const stores = record.customer.stores
    .filter(store => {
      if (record.type === 'STORE_CUSTOMER') {
        return store._id === record.store._id;
      }
      return true;
    });

    return (
      <ColumnTagWrapper>
        {stores.map((store, _index) => (
          <AntdTag key={store._id}>
            <Link to={`/stores/${store._id}`}>
              {store.name}
            </Link>
          </AntdTag>
        ))}
      </ColumnTagWrapper>
    );
  },
}

export const columnName = {
  title: 'Name',
  path: 'customerDetails.name',
  sort: 'name',
  link: '/customers/:_id',
  // render: record => record.customerDetails?.name || record.store.name,
};

export const columnNameSeller = {
  title: 'Name',
  path: 'customerDetails.name',
  sort: 'name',
  link: '/store/customers/:_id',
}

export const ADMIN = [
  columnName,
  columnEmail,
  columnPhoneNumber,
  columnOrdersCountDelivered,
  columnTotalSpent,
  columnLastOrder,
  columnStore,
  columnCities,
  columnCountries,
];

export const SELLER = [
  columnNameSeller,
  columnEmail,
  columnPhoneNumber,
  columnCities,
  columnCountries,
  columnLastOrder,
  columnTotalSpent,
  columnOrdersCountDelivered,
];
